import Color from '../Color.mjs'
import superMeta from '../_COMPONENT/metaComponentNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.CYAN,
    codeProp: 'ruleUserCode',
    mapProp: 'ruleMap',
    name: '业务规则',
    ownerIdProp: 'bdId',
    ownerTextProp: 'bdName',
    ownerType: 'BD',
    textProp: 'ruleTitle',
    type: 'BDRULE',
}
